module.exports = __webpack_public_path__ + "static/media/nota_production.f7782774.svg";